import React from 'react'
import SpeakingPaula from './components/SpeakingPaula';
import ChatSection from './components/ChatSection';
interface AgentProps {
    onClose: () => void;
    show: boolean;
}
const SproutsAgent: React.FC<AgentProps> = ({ onClose, show }) => {
    return (
        <div className='sprouts-agent-container'>
            {/* <SpeakingPaula /> */}
            <ChatSection onClose={onClose} show={show} />
        </div>
    )
}

export default SproutsAgent;
